/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_ReviewedInputs */

const en_orders_review_reviewed = /** @type {(inputs: Orders_Review_ReviewedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviewed`)
};

const es_orders_review_reviewed = /** @type {(inputs: Orders_Review_ReviewedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisado`)
};

/**
* | output |
* | --- |
* | "Reviewed" |
*
* @param {Orders_Review_ReviewedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_reviewed = /** @type {((inputs?: Orders_Review_ReviewedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_ReviewedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_reviewed(inputs)
	return es_orders_review_reviewed(inputs)
});